import React, { useEffect } from 'react'
import { SelectCP } from 'submodules/nerit-framework-ui/common/components/form-fields/select/SelectCP'
import { IFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/types/IFormStateManager'
import { useRequest } from 'submodules/nerit-framework-ui/common/request-manager/use-request/UseRequest'
import { RequestUtils } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/RequestUtils'
import { NotificationHelper } from 'submodules/nerit-framework-ui/common/components/notification/inner/NotificationHelper'
import { ISearchResult } from 'submodules/nerit-framework-utils/sdk-utils/dtos/interfaces/ISearchResult'
import { ParameterGroupRequests } from 'submodules/nerit-aquatec-sdk/services/parameter-group/ParameterGroupRequests'
import { ParameterGroupResponseDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-group/dtos/responses/ParameterGroupResponseDTO'

interface ICPProps {
    isRequired?: boolean
    onChange?: (groupCode?: number) => void
    fieldName?: string
    formStateManager?: IFormStateManager<any>
    width?: number
}

/**
 * Select de Grupo de Parametros. Ao escolher um grupo o consumidor deve
 * prefixar o filtro de parametros com os campos do grupo.
 */
export function SelectParameterGroupCP(props: ICPProps): JSX.Element {

    const searchRequest = useRequest<ISearchResult<ParameterGroupResponseDTO>>()
    useEffect(onSearchRequestChange, [searchRequest.isAwaiting])

    useEffect(init, [])

    function init(): void {
        searchRequest.runRequest(ParameterGroupRequests.search({ itemsPerPage: 999, page: 1 }))
    }

    function onSearchRequestChange(): void {
        RequestUtils.isValidRequestReturn(searchRequest, NotificationHelper.DEFAULT_ERROR_GET_MESSAGE)
    }

    const groups = searchRequest.responseData?.list ?? []

    return (
        <SelectCP
            label={'Grupo de Parâmetros'}
            required={!!props.isRequired}
            loading={searchRequest.isAwaiting}
            allowClear={true}
            options={groups.map((group) => ({
                value: group.code,
                label: `${group.name} (${group.totalFields})`,
            }))}
            onChange={props.onChange}
            width={props.width}
            formStateManager={props.formStateManager}
            fieldName={props.fieldName}
        />
    )
}
